import React from 'react'

interface VideoPreviewProps {
  url: string
  width?: string | number
  height?: string | number
}

// Helper function to extract video ID and determine platform
const parseVideoUrl = (url: string) => {
  // Loom: https://www.loom.com/share/VIDEO_ID
  const loomMatch = url.match(/loom\.com\/share\/([a-zA-Z0-9]+)/)
  if (loomMatch) {
    return {platform: 'loom', id: loomMatch[1]}
  }

  // YouTube: various formats
  const youtubeMatch =
    url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/) ||
    url.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]+)/)
  if (youtubeMatch) {
    return {platform: 'youtube', id: youtubeMatch[1]}
  }

  // Vimeo: https://vimeo.com/VIDEO_ID
  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/)
  if (vimeoMatch) {
    return {platform: 'vimeo', id: vimeoMatch[1]}
  }

  return null
}

export const VideoPreview: React.FC<VideoPreviewProps> = ({url, width = '100%', height = 400}) => {
  const videoInfo = parseVideoUrl(url)

  if (!videoInfo) {
    // Si no es un video reconocido, mostrar un enlace simple
    return (
      <div
        style={{
          width,
          height,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: 4,
        }}
      >
        <i className="bi bi-link-45deg" style={{fontSize: 48, color: '#6c757d', marginBottom: 16}} />
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
          style={{textDecoration: 'none'}}
        >
          <i className="bi bi-box-arrow-up-right me-2" />
          Open External Link
        </a>
        <small className="text-muted mt-2" style={{maxWidth: '80%', textAlign: 'center', wordBreak: 'break-all'}}>
          {url}
        </small>
      </div>
    )
  }

  let embedUrl = ''

  switch (videoInfo.platform) {
    case 'loom':
      embedUrl = `https://www.loom.com/embed/${videoInfo.id}`
      break
    case 'youtube':
      embedUrl = `https://www.youtube.com/embed/${videoInfo.id}`
      break
    case 'vimeo':
      embedUrl = `https://player.vimeo.com/video/${videoInfo.id}`
      break
  }

  return (
    <div style={{width, height}}>
      <iframe
        src={embedUrl}
        width="100%"
        height="100%"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{borderRadius: 4}}
      />
    </div>
  )
}
